import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { empty } from 'rxjs';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import {UrlPrefix} from "../constants/url-prefix.constants";
@Injectable()
export class TokenResolverService {
  http: HttpClient;
  private _accessToken: string;
  private _tokenExpiration: number;
  private _accessTokenRefreshIntervalId: number;
  constructor(private handler: HttpBackend) {
    // avoid interceptors
    this.http = new HttpClient(this.handler);
  }
  resolve(): Promise<void> {
    if (environment.production) {
      return this.getTokenForProduction();
    } else {
      return this.getTokenForDevelopment();
    }
  }

  private setRefreshAccessTokenLoop() {
    if(this._accessTokenRefreshIntervalId) {
      window.clearInterval(this._accessTokenRefreshIntervalId);
    }
    const expires = this._tokenExpiration;
    const defaultExpiration = 5 * 60; // default interval = 5 minutes
    let interval = expires && !isNaN(+expires) ? +expires - 1 : defaultExpiration;

    this._accessTokenRefreshIntervalId = window.setInterval(() => {
      this.resolve().then(() => { }, (error) => alert(error));
    }, interval * 1000);
  }

  public get accessToken() {
    return this._accessToken;
  }

  private getTokenForProduction() {
    return this.http
      .get(`${environment.url}/${UrlPrefix.TOKEN_API_PREFIX_PROD}`, { headers: this.generateHeaders() })
      .pipe(catchError((err, caught) => {
        // if an error occurs, user will be redirected to login page as his/her session is no longer valid
        window.location.href = `${window.location.origin}/Login.aspx?nextUrl=Default.aspx`;
        return empty();
      }), tap((x: any) => {
        this._accessToken = x.access_token;
        this._tokenExpiration = x.expires_in;
        this.setRefreshAccessTokenLoop();
      })).toPromise();
  }
  private getTokenForDevelopment() {
    const payload = `grant_type=password&username=${
      environment.userName
      }&password=${environment.password}`;
    return this.http
      .post(`${environment.url}/${UrlPrefix.TOKEN_API_PREFIX_DEV}`, payload, { headers: this.generateHeaders(true) })
      .pipe(tap((x: any) => {
        this._accessToken = x.access_token;
        this._tokenExpiration = x.expires_in;
        this.setRefreshAccessTokenLoop();
      }, error => { alert('Could not obtain access token, please check environment.ts') })).toPromise();
  }
  private generateHeaders(includeContentType?: boolean): HttpHeaders {
    const headers = {
      'Pragma': 'no-cache',
      'Cache-Control': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT'
    };

    if (environment.production) {
      headers['X-CSRF-Token'] = localStorage.getItem('CSRF');
    }
    if (includeContentType) {
      headers['Content-Type'] = 'application/json';
    }
    return new HttpHeaders(headers);
  }
}
